import ColorHash, { ColorValueArray } from 'color-hash';

export const hexToRgb = (hex: string): [number, number, number] => {
    if (hex[0] !== '#' || (hex.length !== 4 && hex.length !== 7)) {
        throw new Error('Invalid hex format');
    }

    let r = 0,
        g = 0,
        b = 0;

    if (hex.length === 4) {
        r = Number.parseInt(hex[1] + hex[1], 16);
        g = Number.parseInt(hex[2] + hex[2], 16);
        b = Number.parseInt(hex[3] + hex[3], 16);
    } else if (hex.length === 7) {
        r = Number.parseInt(hex[1] + hex[2], 16);
        g = Number.parseInt(hex[3] + hex[4], 16);
        b = Number.parseInt(hex[5] + hex[6], 16);
    }

    if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) {
        throw new TypeError('Invalid hex format');
    }

    return [r, g, b];
};

export const colorHash: ColorHash = new ColorHash();

export const generateHexColor = (value: string): string => {
    return colorHash.hex(value);
};

export const generateRGBColor = (value: string): ColorValueArray => {
    return colorHash.rgb(value);
};

export const generateHSLColor = (value: string): ColorValueArray => {
    return colorHash.hsl(value);
};
